import React from "react";
import Reveal from "@/components/site/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSiteContent } from "@/lib/siteContent";
import { useSeo } from "@/lib/useSeo";
import { PageHeader } from "./AboutPage";

export default function FAQPage() {
  const { content, loading } = useSiteContent();
  useSeo("FAQ", "FAQ");
  if (loading || !content) return null;
  return (
    <div data-testid="faq-page">
      <PageHeader title="FAQ" script="Questions?" subtitle="Everything you need to know before booking." />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-5 lg:px-10">
          <Reveal>
            <Accordion type="single" collapsible className="bg-white rounded-3xl shadow-cozy border border-cozy-gold/15 px-6 lg:px-8">
              {(content.faqs || []).map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b last:border-0 border-cozy-gold/10" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="font-serif text-lg text-left text-cozy-brown hover:text-cozy-gold py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-cozy-brown-soft leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
